import {
  IonAccordionGroup,
  IonAccordion,
  IonItem,
  IonLabel,
  IonList,
  IonIcon
} from '@ionic/react';
import React, { useState } from 'react';
import './CatalogAccordion.scss';
import CompleteIcon from 'assets/icons/complete.svg';
import ArrowIcon from 'assets/icons/arrow-right.svg';

type AccordionProps = {
  label?: string;
  value?: string;
  description?: string;
  complete?: boolean;
  className?: string;
};

const CatalogAccordion: React.FC<AccordionProps> = ({
  label = 'Items',
  value = '',
  description = '',
  complete = null,
  className,
  children,
  ...rest
}) => {
  // Track expand/collapse in local state so a parent re-render (e.g. opening the
  // catalog task modal, which flips modalDetailsVisible) doesn't reset it.
  // Seed once from `complete` — finished groups start collapsed — but after that
  // only a manual header click, via onIonChange, changes it. `multiple` expects
  // an array of open accordion values, so keep it as string[].
  const [openValues, setOpenValues] = useState<string[]>(
    complete ? [] : [value]
  );

  return (
    <IonAccordionGroup
      multiple={true}
      value={openValues}
      onIonChange={(e) => setOpenValues(e.detail.value ?? [])}
      className={className}
    >
      <IonAccordion
        className="hk-accordion"
        toggleIcon={ArrowIcon}
        toggleIconSlot={'start'}
        value={value}
      >
        <IonItem className="hk-accordion-header" slot="header">
          <IonLabel>{label}</IonLabel>
          {complete !== null && (
            <div className="hk-accordion-header-task">
              {complete === true ? (
                <IonIcon color="primary" icon={CompleteIcon} />
              ) : (
                <div className="hk-accordion-header-task-circle"></div>
              )}
            </div>
          )}
        </IonItem>

        <IonList className="hk-accordion-content" slot="content">
          {children}
        </IonList>
      </IonAccordion>
    </IonAccordionGroup>
  );
};

export default CatalogAccordion;
